import { X } from "lucide-react";

import type { DirectoryMatch } from "../api/types";
import { Avatar } from "../ui/Avatar";
import { DirectoryPicker } from "./DirectoryPicker";

/** Several people, as chips, with a search box to add more: group members, or a ticket's people. */
export function PeopleField({
  label,
  addLabel,
  hint,
  people,
  onChange,
  exclude = [],
}: {
  label: string;
  addLabel: string;
  hint?: string;
  people: DirectoryMatch[];
  onChange: (people: DirectoryMatch[]) => void;
  /** Emails that can't be added (e.g. the requester). */
  exclude?: string[];
}) {
  return (
    <div className="field">
      <span className="field-label">{label}</span>
      {people.length ? (
        <ul className="member-chips" aria-label={label}>
          {people.map((person) => (
            <li key={person.email} className="member-chip">
              <Avatar name={person.name} seed={person.email} size="sm" />
              <span className="member-chip-name">{person.name}</span>
              <button
                type="button"
                className="icon-btn icon-btn-sm"
                aria-label={`Remove ${person.name}`}
                onClick={() => onChange(people.filter((p) => p.email !== person.email))}
              >
                <X size={14} aria-hidden="true" />
              </button>
            </li>
          ))}
        </ul>
      ) : null}
      {/* A fresh search box after each pick. */}
      <DirectoryPicker
        key={people.length}
        label={addLabel}
        {...(hint ? { hint } : {})}
        value={null}
        onChange={(person) => {
          const email = person?.email.toLowerCase();
          if (!person || !email || exclude.some((e) => e.toLowerCase() === email)) return;
          if (!people.some((p) => p.email.toLowerCase() === email)) onChange([...people, person]);
        }}
      />
    </div>
  );
}
